module.exports = __webpack_public_path__ + "img/bird-1.8b479923.png";